import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { listRewardHistoryUsers, updateRewardPoints } from "../../Redux/Actions/rewardsAction";
import { columnsDoneRewardsUserPoints } from "../../Global Functions/columnsAntd";
import toast from "react-hot-toast";
import DateRangePopup from "../../Utils/dateFilterPopup";
import TableComponentsCp from "../../Global Functions/tableComponentsCp";

const ListDoneUserRewards = () => {
  const dispatch = useDispatch();

  const rewardHistory = useSelector((state) => state.rewards?.rewardHistoryList || {});
  const loading = useSelector((state) => state.rewards?.loading);
  const [searchQuery, setSearchQuery] = useState("");
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const fetchDetails = useCallback(
    (page, limit, showLoader = true) => {
      const payload = {
        page,
        limit,
        is_deleted: false,
        search: debouncedSearch,
      };
      dispatch(listRewardHistoryUsers(payload, showLoader)).catch(() => {
        if (!showLoader) {
          toast.error("Failed to refresh reward history list");
        }
      });
    },
    [dispatch, debouncedSearch]
  );

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
  }, [pagination.current, pagination.pageSize, fetchDetails]);


  useEffect(() => {
    if (rewardHistory?.total) {
      setPagination((prev) => ({
        ...prev,
        total: rewardHistory.total,
      }));
    }
  }, [rewardHistory]);

  const handleTableChange = (pager) => {
    setPagination(pager);
  };

  const filterHandler = () => {
    setSearchQuery(debouncedSearch);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const handleStatusChange = async (record, action) => {
    if (action === "active" || action === "inactive") {
      const payload = {
        id: record._id,
        status: action,
      };
      await dispatch(updateRewardPoints(payload));
      fetchDetails(pagination.current, pagination.pageSize);
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchQuery]);

  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  return (
    <>
      <TableComponentsCp
        h3heading="Done User Reward List"
        pagination={pagination}
        onChange={handleTableChange}
        columns={columnsDoneRewardsUserPoints(handleStatusChange)}
        dataSource={Array.isArray(rewardHistory?.data) ? rewardHistory.data : []}
        loading={loading}
        onCalendarClick={() => setIsDatePopupVisible(true)}
        setState={setSearchQuery}
        filterFunction={filterHandler}
      />

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />
    </>
  );
};

export default ListDoneUserRewards;
